export default function PreferenceViewer({
  title = "Title",
  customInputsValue,
}: any) {
  // 1. Safety Check
  if (
    !customInputsValue ||
    (Array.isArray(customInputsValue) && customInputsValue.length === 0)
  ) {
    return null;
  }

  const isArray = Array.isArray(customInputsValue);

  return (
    <div className="flex flex-col gap-2 py-3 w-full">
      {/* Label */}
      <p className="font-medium text-[#171717] text-[14px] tracking-[-0.32px] opacity-80">
        {title}
      </p>

      {/* --- CONTENT RENDERER --- */}
      {isArray ? (
        // CASE A: ARRAY (Clean Pills)
        <div className="flex flex-wrap gap-2 items-center">
          {customInputsValue.map((val: string, index: number) => (
            <div
              key={index}
              className="bg-[#FDFDFD] border border-[#E5E5E5] px-3 py-1.5 rounded-[10px] shadow-sm"
            >
              <p className="font-medium text-[#404040] text-[13px] tracking-[-0.2px] whitespace-nowrap">
                {val}
              </p>
            </div>
          ))}
        </div>
      ) : (
        // CASE B: SINGLE VALUE (Stable "Read-Only Field" Look)
        <div className="w-full">
          <div className="bg-[#fcfcfc] border border-[#e5e5e5] rounded-[12px] px-4 py-2.5 w-full flex items-center min-h-[44px]">
            <p className="text-[14px] text-[#171717] tracking-[-0.2px] font-normal leading-relaxed whitespace-pre-wrap">
              {String(customInputsValue)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
